import { useRef, useState } from 'react';
import { useLanguage } from '@/i18n/LanguageProvider';

export default function LanguageSwitch() {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const langMenuRef = useRef<HTMLDivElement>(null);

  return (
    <div className="relative" ref={langMenuRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-1 text-white hover:text-[#B9AE9A] transition-colors px-2 py-1 rounded-md border border-transparent hover:border-[#B9AE9A]/20"
      >
        <span className={`text-sm font-bauhaus ${language === 'DE' ? 'text-[#B9AE9A]' : ''}`}>
          {language}
        </span>
        <svg 
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180 text-[#B9AE9A]' : ''}`} 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-24 rounded-md shadow-lg bg-[#1C1C1C]/90 backdrop-blur-md border border-[#B9AE9A]/20 overflow-hidden z-10">
          <div className="py-1">
            {(['EN', 'DE', 'CN'] as const).map((lang) => (
              <button
                key={lang}
                className={`block w-full text-left px-4 py-2 text-sm font-bauhaus ${language === lang ? 'text-[#B9AE9A]' : 'text-white/70 hover:text-white'}`}
                onClick={() => {
                  setLanguage(lang);
                  setIsOpen(false);
                }}
              >
                {lang}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
} 